import { CommonResponse, returnException } from '@boi/backend-utils';
import { ClassQnpMRequestModel, ClassRequestModel, CreatePaperModelReq, SubjectClassReqModel } from '@boi/shared-models';
import { Injectable } from '@nestjs/common';
import { QuestionPaperModalAdapter } from './dtos/model-paper.adapter';
import { ModelPaperRepo } from './repositories/model-paper-repo';
import { In } from 'typeorm';
import { LanguagesRepo } from '../ai-generated-qp/repo/languages-repo';
import { SubjectRepo } from '../ai-generated-qp/repo/subject-repo';
import { ChapterRepo } from '../ai-generated-qp/repo/chapter-repo';
import { Chapter } from '../entities/chapter';

@Injectable()
export class ModelPaperService {
    constructor(
        private modelPaperRepo: ModelPaperRepo,
        private qnpModalAdapter: QuestionPaperModalAdapter,
        private languageRepo: LanguagesRepo,
        private subjectMasterRepo: SubjectRepo,
        private chapterMasterRepo: ChapterRepo,
    ) { }

    safeStringify(obj) {
        const seen = new WeakSet();
        return JSON.stringify(obj, (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    return; // skip circular reference
                }
                seen.add(value);
            }
            return value;
        });
    }


    async createModelPaper(createPaperModelReq: CreatePaperModelReq): Promise<CommonResponse> {
        try {
            const baseLanguageId = Number(createPaperModelReq.language);
            const baseSubId = Number(createPaperModelReq.subject)
            const baseSubjectEntity = await this.subjectMasterRepo.findOne({ where: { id: baseSubId } });
            let baseModelPaperId
            const saveRecordIds = [];
            for (const rec of createPaperModelReq.languages) {
                const findLang = await this.languageRepo.findOne({ where: { id: rec } })
                const req = JSON.parse(JSON.stringify(createPaperModelReq))
                req.language = rec;
                const subjectEntity = await this.subjectMasterRepo.findOne({ where: { class: req.classId, language: rec, subjectParentId: baseSubjectEntity.id } });
                const entity = this.qnpModalAdapter.convertDtoToEntity(req);
                entity.tagline = `${findLang.language} Version`;
                entity.subject = subjectEntity.id;
                for (const section of entity.sectionsWiseModel) {
                    for (const chapterWiseModel of section.chapterWiseModel) {
                        const baseChapterId = Number(chapterWiseModel.chapter.id);
                        const baseChapterEntity = await this.chapterMasterRepo.findOne({ where: { id: baseChapterId } });
                        const chapterEntity = await this.chapterMasterRepo.findOne({ where: { subject: subjectEntity.id, chapterParentId: baseChapterEntity.chapterParentId } });
                        if (!chapterEntity) {
                            throw new Error(`No corresponding chapter found for language ${findLang.language} (ID: ${rec}) for base chapter ${baseChapterId}`);
                        }
                        const chapter = new Chapter();
                        chapter.id = chapterEntity.id
                        chapterWiseModel.chapter = chapter;
                    }
                }
                // console.log(this.safeStringify(entity), 'entity');
                console.log('Entity_________', entity)

                const saveData = await this.modelPaperRepo.save(entity);
                if (rec == baseLanguageId) {
                    baseModelPaperId = saveData.id
                }
                saveRecordIds.push(saveData.id);
            }
            await this.modelPaperRepo.update({ id: In(saveRecordIds) }, { mainModelPaperId: baseModelPaperId });
            return new CommonResponse(true, 55, `${createPaperModelReq.id ? 'Model Paper Updated' : 'Model Paper Created'} Successfully`);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    async getModelPaperDataBySubject(req: SubjectClassReqModel): Promise<CommonResponse> {
        // const result = await this.modelPaperRepo.find({ where: { subject: req.subject, class: req.classId }, relations: ['sectionsWiseModel'] })
        const result = await this.modelPaperRepo.getModelPaperDataBySubjectRepo(req)
        if (result.length > 0) {
            return new CommonResponse(true, result.length, 'Model Papers data retriveed successfully', result)
        } else {
            return new CommonResponse(false, 0, "No Data Found")
        }
    }

    async getAllModelPaperData(req: ClassRequestModel): Promise<CommonResponse> {
        const result = await this.modelPaperRepo.getAllModelPaperData(req);
        return new CommonResponse(true, result.length, 'All model papers data retrived successfully', result)
    }

    async getModelPaperData(req: ClassQnpMRequestModel): Promise<CommonResponse> {
        const result = await this.modelPaperRepo.getModelPaperData(req);
        result['sections'] = await this.modelPaperRepo.getSectionWiseModelPaperData(req);
        return new CommonResponse(true, result.length, 'All model papers data retrived successfully', result)
    }
}
